import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "../../assets/css/AddedCss.css";
import { AddNode } from "../../services/apiUtils";
import { Modal, notification } from "antd";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const MasterAdd = ({ setNodeAdd, setModalShow, master, setHideContent }) => {
  const [nodeName, setNodeName] = useState("");
  const [nodeType, setNodeType] = useState(null);
  const [valves, setValves] = useState([]);
  const [valveStatus, setValveStatus] = useState({});
  const [errors, setErrors] = useState({});
  const [user, setUserId] = useState();
  const [showValveInputs, setShowValveInputs] = useState(false);
  const [NodeData, setNodeData] = useState();
  const [nodeId, setNodeId] = useState("");
  const [valveIds, setValveIds] = useState({});
  const history = useHistory();

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (userId) setUserId(userId);
  }, []);

  const validateStepOne = () => {
    let formErrors = {};
    if (!nodeName.trim()) formErrors.nodeName = "Node Name is required";
    if (!nodeType) formErrors.nodeType = "Please select a node type";
    if (!nodeId.trim()) formErrors.nodeId = "Node ID is required";
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const validateStepTwo = () => {
    let formErrors = {};
    valves.forEach((valve, index) => {
      if (!valve.trim())
        formErrors[`valve_${index}`] = `Valve ${index + 1} name is required`;
      if (!valveIds[index]?.trim())
        formErrors[`valveId_${index}`] = `Valve ${index + 1} ID is required`;
    });
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleNext = () => {
    if (validateStepOne()) {
      const FullData = {
        Created_by: user,
        MasterId: master.MasterId,
        NodeName: nodeName,
        NodeID: nodeId,
        NodeType: nodeType,
        Status: 1,
      };
      setNodeData(FullData);
      setShowValveInputs(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateStepTwo()) return;

    try {
      const valvesWithId = valves.map((valve, index) => ({
        ValveID: valveIds[index],
        ValveName: valve,
        Status: valveStatus[index] ?? 1,
      }));

      const FullData = {
        ...NodeData,
        Valvelist: valvesWithId,
      };

      await AddNode(FullData);
      notification.success({
        message: "Successful",
        description: "Valve Registration Successful!",
      });
      history.push("/master");
      setNodeAdd(false);
      setHideContent(true);
      setModalShow(false);
    } catch (error) {
      notification.error({
        message: "Error",
        description: "Valve Registration Error" + error,
      });
    }
  };

  return (
    <Modal
      open={true}
      centered
      width={700}
      footer={null}
      destroyOnClose
      title={
        <div className="d-flex align-items-center gap-2">
          <button
            type="button"
            className="btn btn-link p-0"
            onClick={() => {
              if (showValveInputs) {
                setShowValveInputs(false);
              } else {
                setNodeAdd(false);
                setModalShow(true);
              }
            }}
          >
            Back
          </button>
          <h5 className="mb-0 text-uppercase">Node Add</h5>
        </div>
      }
      onCancel={() => {
        setNodeAdd(false);
        setModalShow(true);
      }}
    >
      <form onSubmit={handleSubmit} className=" mb-5">
        {!showValveInputs ? (
          <>
            <div className="mt-3">
              {/* STEP 1 */}
              <div className="form-group">
                <input
                  type="text"
                  value={nodeName}
                  onChange={(e) => setNodeName(e.target.value)}
                  className="form-control"
                  placeholder="Enter Node Name"
                />
                {errors.nodeName && (
                  <p className="error-text">{errors.nodeName}</p>
                )}
              </div>

              <div className="form-group">
                <input
                  type="text"
                  value={nodeId}
                  onChange={(e) => setNodeId(e.target.value)}
                  className="form-control"
                  placeholder="Enter Node ID"
                />
                {errors.nodeId && <p className="error-text">{errors.nodeId}</p>}
              </div>

              <h3 className="node-type">Select Node Type</h3>
              <div className="d-flex gap-3 mb-4">
                {[1, 2, 4].map((num) => (
                  <button
                    key={num}
                    type="button"
                    className={`btn btn-primary ${
                      nodeType === num ? "active" : ""
                    }`}
                    onClick={() => {
                      setNodeType(num);
                      setValves(
                        Array(num)
                          .fill("")
                          .map((_, i) => `Valve ${i + 1}`)
                      );
                      setValveStatus(
                        Object.fromEntries(
                          Array(num)
                            .fill(1)
                            .map((_, i) => [i, 1])
                        )
                      );
                    }}
                  >
                    {num} Valve{num > 1 ? "s" : ""}
                  </button>
                ))}
              </div>

              {errors.nodeType && (
                <p className="error-text">{errors.nodeType}</p>
              )}
            </div>

            <button
              type="button"
              className="btn btn-primary next-btn"
              onClick={handleNext}
            >
              Next
            </button>
          </>
        ) : (
          <>
            {/* STEP 2 */}
            <h3 className="node-type mt-3">Enter Valve Names & Set Status</h3>

            {valves.map((valve, index) => (
              <div key={index} className="valve-group mb-4 p-3 border rounded">
                <div className="row g-3 align-items-center">
                  {/* Valve Name */}
                  <div className="col-md-4">
                    <input
                      type="text"
                      value={valve}
                      onChange={(e) =>
                        setValves((prev) =>
                          prev.map((v, i) => (i === index ? e.target.value : v))
                        )
                      }
                      className={`form-control ${
                        errors[`valve_${index}`] ? "is-invalid" : ""
                      }`}
                      placeholder={`Valve ${index + 1} Name`}
                    />
                    {errors[`valve_${index}`] && (
                      <div className="invalid-feedback">
                        {errors[`valve_${index}`]}
                      </div>
                    )}
                  </div>

                  {/* Valve ID */}
                  <div className="col-md-4">
                    <input
                      type="text"
                      value={valveIds[index] || ""}
                      onChange={(e) =>
                        setValveIds((prev) => ({
                          ...prev,
                          [index]: e.target.value,
                        }))
                      }
                      className={`form-control ${
                        errors[`valveId_${index}`] ? "is-invalid" : ""
                      }`}
                      placeholder={`Valve ${index + 1} ID`}
                    />
                    {errors[`valveId_${index}`] && (
                      <div className="invalid-feedback">
                        {errors[`valveId_${index}`]}
                      </div>
                    )}
                  </div>

                  {/* Status Switch */}
                  <div className="col-md-4 d-flex align-items-center gap-2">
                    <div className="form-check form-switch">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        checked={valveStatus[index] === 1}
                        onChange={() =>
                          setValveStatus((prev) => ({
                            ...prev,
                            [index]: prev[index] === 1 ? 0 : 1,
                          }))
                        }
                      />
                    </div>
                    <span
                      className={`fw-semibold ${
                        valveStatus[index] === 1
                          ? "text-success"
                          : "text-danger"
                      }`}
                    >
                      {valveStatus[index] === 1 ? "ON" : "OFF"}
                    </span>
                  </div>
                </div>
              </div>
            ))}

            <button type="submit" className="btn btn-success">
              Submit
            </button>
          </>
        )}
      </form>
    </Modal>
  );
};

export default MasterAdd;

MasterAdd.propTypes = {
  setNodeAdd: PropTypes.func.isRequired,
  setModalShow: PropTypes.func.isRequired,
  setHideContent: PropTypes.func.isRequired,
  master: PropTypes.object.isRequired,
};
